import React from 'react';
import StandaloneMain from './views/standalone.c';
import Wrapper from './views/main.c';

const Standalone = props => <Wrapper {...props} component={StandaloneMain} />;

export default Standalone;
